import { useEffect } from "react";
import { SESSION_STORAGE_CONSTS } from "../constants";

interface UseRedirectUrlCodeProps {
  callbackWithUrlCode: URL | null;
}

const useRedirectUrlCode = ({
  callbackWithUrlCode,
}: UseRedirectUrlCodeProps) => {
  useEffect(() => {
    if (callbackWithUrlCode) {
      // clear the session storage for the next new login attempt
      window.sessionStorage.removeItem(SESSION_STORAGE_CONSTS.APPLICATION_ID);
      window.sessionStorage.removeItem(SESSION_STORAGE_CONSTS.CALLBACK_URL);
      window.location.assign(callbackWithUrlCode);
    }
  }, [callbackWithUrlCode]);
};

export default useRedirectUrlCode;
